import type { SiteGisDate } from "@safers/api";

export interface AerialPhotoCatalog {
  siteId: number | null;
  photos: readonly SiteGisDate[];
  isLoading?: boolean;
  isError?: boolean;
  onRetry?: () => void;
}

export interface AerialTileSource {
  url: string;
  attribution: string;
  minZoom: number;
  maxZoom: number;
  maxNativeZoom: number;
}

export const EMPTY_AERIAL_PHOTOS: AerialPhotoCatalog = { siteId: null, photos: [] };

const MAX_ZOOM = 22;

function isPhotoDate(date: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
  const timestamp = Date.parse(`${date}T00:00:00Z`);
  return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === date;
}

function isValidPhoto(photo: SiteGisDate): boolean {
  return (
    isPhotoDate(photo.captureDate) &&
    Number.isInteger(photo.minZoom) &&
    Number.isInteger(photo.maxZoom) &&
    photo.minZoom >= 0 &&
    photo.maxZoom >= photo.minZoom &&
    photo.maxZoom <= 30
  );
}

export function aerialPhotoDates(photos: readonly SiteGisDate[]): string[] {
  return [...new Set(photos.filter(isValidPhoto).map((photo) => photo.captureDate))]
    .sort()
    .reverse();
}

export function aerialPhotoSource(photo: SiteGisDate | undefined): AerialTileSource | null {
  if (!photo || !isValidPhoto(photo)) return null;
  const directory = photo.captureDate.replaceAll("-", "");
  return {
    url: `/tiles/${directory}/{z}/{x}/{y}.webp`,
    attribution: "현장 항공사진",
    minZoom: photo.minZoom,
    maxNativeZoom: photo.maxZoom,
    maxZoom: Math.max(MAX_ZOOM, photo.maxZoom),
  };
}
